import {Tab} from "@atlaskit/tabs";
import type {ComponentProps} from "react";
// import styles1 from "@atlaskit/tabs/dist/esm/components/tab-list.compiled.css?raw";
// import styles2 from "@atlaskit/tabs/dist/esm/components/tabs.compiled.css?raw";

export function AnankeTab(props: ComponentProps<typeof Tab>) {
    return (
        <>
            {/* Trying to fix the default text color on hover. Not working for now. (basically the currently
            selected tab's text color goes from blue to gray on hover - this is not the expected behavior,
            and not this behaves on ADS website) */}
            {/* <style dangerouslySetInnerHTML={{__html: styles1}} />
            <style dangerouslySetInnerHTML={{__html: styles2}} /> */}
            <Tab {...props} />
        </>
    );
}
